module.exports = __webpack_public_path__ + "static/media/background-1200.de2d5089.jpg";